import type { AxisScale } from '@visx/xychart';

/**
 * Gets the bandwidth of a band scale, or 0 for continuous scales.
 * Copied from visx internal utilities.
 */
export function getScaleBandwidth<Scale extends AxisScale>(scale?: Scale): number {
  // Broaden type before using 'xxx' in s as typeguard.
  const s = scale as AxisScale;
  return s && 'bandwidth' in s ? (s?.bandwidth() ?? 0) : 0;
}
